/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type UserCard_user = {
    readonly id: string;
    readonly rowId: string;
    readonly slugId: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly bio: string | null;
    readonly isMe: boolean | null;
    readonly isFollowing: boolean | null;
    readonly backgroundPhoto: {
        readonly id: string;
    } | null;
    readonly organizerGuildMemberships: {
        readonly " $fragmentRefs": FragmentRefs<"UserCard_GuildMembershipBadgesFragment">;
    };
    readonly editorGuildMemberships: {
        readonly " $fragmentRefs": FragmentRefs<"UserCard_GuildMembershipBadgesFragment">;
    };
    readonly " $fragmentRefs": FragmentRefs<"UserFollowingStatus_user" | "UserPrimaryPhoto_user" | "UserBackgroundPhoto_user">;
    readonly " $refType": "UserCard_user";
};
export type UserCard_user$data = UserCard_user;
export type UserCard_user$key = {
    readonly " $data"?: UserCard_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"UserCard_user">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v2 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "UserCard_GuildMembershipBadgesFragment"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserCard_user",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slugId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bio",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMe",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFollowing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "backgroundPhoto",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": "organizerGuildMemberships",
      "args": [
        {
          "kind": "Literal",
          "name": "condition",
          "value": {
            "membershipLevel": "ORGANIZER"
          }
        },
        (v1/*: any*/)
      ],
      "concreteType": "GuildMembershipsConnection",
      "kind": "LinkedField",
      "name": "guildMemberships",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": "guildMemberships(condition:{\"membershipLevel\":\"ORGANIZER\"},first:3)"
    },
    {
      "alias": "editorGuildMemberships",
      "args": [
        {
          "kind": "Literal",
          "name": "condition",
          "value": {
            "membershipLevel": "EDITOR"
          }
        },
        (v1/*: any*/)
      ],
      "concreteType": "GuildMembershipsConnection",
      "kind": "LinkedField",
      "name": "guildMemberships",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": "guildMemberships(condition:{\"membershipLevel\":\"EDITOR\"},first:3)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserFollowingStatus_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserPrimaryPhoto_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserBackgroundPhoto_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();
(node as any).hash = '67423d604ab67b80aa7d7492b85b6c31';
export default node;
